import React, { useEffect } from 'react';
import ProductsLineUp from './ProductsLineUp';
import Text from '../../atoms/Text';
import luxeList from '../../constants/luxeScreenType';
import { segmentEventPush } from '../../../modules/ga/GTMdatalayer';

const messages = {
  sectionTitle: 'Shop From Recently Viewed',
  fleekSectionTitle: 'Recently Viewed'
};

interface RecentlyViewedProps {
  products: any,
  action: any,
  productIds: any,
  eventPush: any,
  isPriceReveal: any,
  isPriceRevealDuringSale: any,
  luxe: any,
  isBottomSpace?: boolean | undefined,
  customClass?: string,
  productCode: any,
  isRecentView?: boolean | undefined,
  isFleek?: boolean | undefined,
  isFromHomePage?: boolean | undefined,
  isComingSoonEnabled?: boolean,
  parentProduct?: any
}

const RecentlyViewed = ({
  products,
  action,
  productIds,
  eventPush,
  isPriceReveal,
  isPriceRevealDuringSale,
  luxe,
  isBottomSpace,
  customClass,
  productCode,
  isRecentView,
  isFleek = false,
  isFromHomePage = false,
  isComingSoonEnabled = false,
  parentProduct,
}: RecentlyViewedProps) => {
  useEffect(() => {
    if (productIds) {
      let products = productIds.split(',');
      let filteredProductIds = products?.filter(item => item && item !== productCode);
      action(filteredProductIds);
      if (!luxe) eventPush({ eventName: 'suggestion_widget', widget_name: 'Recently Viewed' });   
    }
  }, [productIds]);

  
 useEffect(() => {

     segmentEventPush({
        event:'Widget Viewed', 
        screen_name: '',            
        widget_id: '',
        widget_name: 'Recently Viewed',
        widget_position: '',
        widget_type: 'Recently Viewed Widget'
      });

 }, [])

  const {
    pdpList: { recentlyList = '' }
  } = luxeList;

  
  
  const title = (
    <Text
      variant={isFromHomePage ? 'T5' : 'T4'}
      weight="bold"
      color={
        luxe && !isFromHomePage
          ? 'Grey_88'
          : isFleek
          ? 'White'
          : isFromHomePage
          ? 'Medium_Black'
          : 'Nero'
      }
      textTransform="is-capitalized"
    >
      {isFromHomePage
        ? 'Recently Viewed'
        : isFleek
        ? messages.fleekSectionTitle
        : messages.sectionTitle}
    </Text>
  );

  const withoutComingSoonProducts = isComingSoonEnabled
    ? (products ?? []).filter(el => (el?.productTag ?? '').toLowerCase() !== 'coming soon')
    : products;

  if (!products?.length) {
    return null;
  }

  let filteredProducts = withoutComingSoonProducts.filter(
    item => item.productColor !== productCode
  );

  if (filteredProducts.length > 0) {
    return (
      <div className={customClass} onClick={e=>{
         segmentEventPush({
            event:'Widget Clicked', 
            screen_name: '',            
            widget_id: '',
            widget_name: 'Recently Viewed',
            widget_position: '',
            widget_type: 'Recently Viewed Widget'
          });
      }}>
        {filteredProducts.length && (
          <ProductsLineUp
            products={filteredProducts}
            luxe={luxe}
            title={title}
            titleGutter="sm"
            isPriceReveal={isPriceReveal}
            isPriceRevealDuringSale={isPriceRevealDuringSale}
            containerClass={isBottomSpace ? 'margin-bottom' : ''}
            eventPush={eventPush}
            eventPushObj={{ event_label: 'recently viewed widget' }}
            pageType={isFromHomePage ? "home screen" : "pdp-msite"}
            pageList={recentlyList}
            isRecentView={isRecentView}
            widgetTitle="Recently"
            isFleek={isFleek}
            isFromHomePage={isFromHomePage}
            parentProduct={parentProduct}
          />
        )}
      </div>
    );
  }

  return null;
};

export default RecentlyViewed;
